import { styled } from "@mui/material/styles";
import React from "react";
import { I18nextProvider, Trans } from "react-i18next";
import { createSupportMailTo } from "../utils/customerSupport";
import { i18next } from "../utils/i18n";
const Div_errorContainer = styled("div")(({ theme }) => ({
    height: "calc(100vh - 9rem)",
    width: "100%",
    backgroundSize: "contain, cover",
    backgroundPosition: "top",
    position: "relative",
    backgroundRepeat: "no-repeat",
    backgroundPositionX: "left",
}));
const Div_errorSection = styled("div")(({ theme }) => ({
    width: "100%",
    height: "auto",
    padding: "0 15rem 0 15rem",
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%,-50%)",
}));
const H1_headline = styled("h1")(({ theme }) => ({
    fontFamily: "BrownStd-Bold",
    fontSize: "18rem",
    textAlign: "center",
}));
const P_subline = styled("p")(({ theme }) => ({
    fontSize: "4rem",
    lineHeight: "5rem",
    fontFamily: "BrownStd-Regular",
    color: "#001a37", //"var(--clr-primary)",
    textAlign: "center",
}));
const P_followUp = styled("p")(({ theme }) => ({
    fontSize: "1.8rem",
    fontFamily: "BrownStd-Regular",
    color: "#001a37", //"var(--clr-primary)",
    textAlign: "center",
}));
const A_errorButton = styled("a")(({ theme }) => ({
    backgroundColor: "#93d1e9", //"var(--clr-blue-light)",
    color: "#001a37", //"var(--clr-primary)",
    padding: "1rem 2.5rem",
    fontFamily: "BrownStd-Regular",
    textTransform: "none",
    textDecoration: "none",
    display: "inline-block",
    transition: "all 0.2s",
    position: "relative",
    fontSize: "1.8rem",
    border: "none",
    cursor: "pointer",
    "&:hover": {
        backgroundColor: "#009fe0", //"var(--clr-secondary)",
        color: "#fff", //"var(--clr-white)",
    },
}));
export const ErrorTemplate = (props) => {
    const i18n = i18next.cloneInstance({
        lng: props.languageCode,
        initImmediate: false,
    });
    const renderTemplate = (errorMessage) => {
        return (React.createElement(I18nextProvider, { i18n: i18n },
            React.createElement(Div_errorContainer, { style: {
                    backgroundImage: "url(" +
                        props.resourceUrl +
                        "images/60deg-scanlines-blue.svg), url(" +
                        props.resourceUrl +
                        "images/bg-blurry-blue.jpg)",
                } },
                React.createElement(Div_errorSection, null,
                    React.createElement(H1_headline, null, props.statusCode),
                    React.createElement(P_subline, null, errorMessage),
                    React.createElement(P_followUp, null,
                        React.createElement(Trans, { i18nKey: "messages:common advice", i18n: i18n, defaults: "Bitte kehren Sie <btnHome>zur Startseite</btnHome> zur\u00FCck oder <btnSupport>kontaktieren Sie unsere IT.</btnSupport>", components: {
                                btnHome: React.createElement(A_errorButton, { href: "/" + props.languageCode }),
                                btnSupport: React.createElement(A_errorButton, { href: createSupportMailTo() }),
                            } }))))));
    };
    if (props.statusCode == 403) {
        return renderTemplate(i18n.t("messages:message 403"));
    }
    if (props.statusCode == 404) {
        return renderTemplate(i18n.t("messages:message 404"));
    }
    if (props.statusCode == 500) {
        return renderTemplate(i18n.t("messages:message 500"));
    }
    return renderTemplate(i18n.t("messages:message undefined"));
};
export default ErrorTemplate;
